// Optimized and cleaned-up version of Advance.js

import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import PageHeading from "../../components/PageHeading";
import { BackButton, HelpButton } from "../../components/btn/Buttons";
import Input from "../../components/inputs/Input";
import TableNew from "../../components/table/TableWithPagination";
import PageLoading from "../../components/PageLoading";
import SmallModal from "../../components/modal/SmallModal";
import Dropdown from "../../components/inputs/Dropdown";
import store from "../../redux/store";
import { get_bank_master_list } from "../MasterData/masterdataSlice";
import { get_advance_list } from "./payrollSlice";

import SearchApiHook from "../../CustomHooks/SearchApiHook";
import { getOptionLabel, NumberDecimalEntry } from "../../utils/OtherFuncs";
import { BankCodeFinder, base_url } from "../../utils/utils";
import { Pagination3 } from "../../components/pagination/pagination";
import usePaginationState from "../../CustomHooks/usePaginationState";
import {
  setLoadingMain,
  setMessAlert,
  setOpenAlert,
} from "../../redux/slice/actionSlice";
import moment from "moment";
import { DateValidator2 } from "../../utils/validation";

const Advance = () => {
  const {
    entries,
    setEntries,
    pageNo,
    setPageNo,
    searchInput,
    setSearchInput,
    totalCount,
    setTotalCount,
    searchCount,
    setSearchCount,
    prevSearch,
    setPrevSearch,
  } = usePaginationState();

  const [EditItem, setEditItem] = useState({});
  const [open, setOpen] = useState(false);
  const [open1, setOpen1] = useState(false);
  const { day_end_date } = useSelector((state) => state.profile);
  const { user_id, today } = useSelector((state) => state.other);
  const { bank_master_list } = useSelector((state) => state.masterdata);
  const { advance_list, advance_loading } = useSelector(
    (state) => state.payroll
  );

  useEffect(() => {
    store.dispatch(get_bank_master_list());
  }, []);

  const apiData = {
    body: {
      action: "staffAdvanceList",
      agencyid: user_id,
      page: pageNo,
      limit: entries,
      search: searchInput,
    },
    data: {
      setTotalCount,
      setSearchCount,
    },
  };

  const fetchData = () => store.dispatch(get_advance_list(apiData));

  SearchApiHook(fetchData, searchInput.trim(), prevSearch, [entries, pageNo]);

  const getRoleOption = useCallback(
    (role) => getOptionLabel(role),
    [advance_list]
  );

  const bankCode = useMemo(
    () => (data) => BankCodeFinder(data),
    [bank_master_list]
  );

  const validate = () => {
    const error = [];
    const data = DateValidator2(
      moment(EditItem?.date).format("DD/MM/YYYY"),
      today,
      day_end_date,
      `Date cant be before as day end Date ${day_end_date}`,
      `Date cant be a future date`
    );
    if (!EditItem?.advance_amount || EditItem?.advance_amount <= 0)
      error.push("Please enter advance amount");
    if (!EditItem?.payment_mode) error.push("Please select mode of payment");
    if (EditItem?.payment_mode != 1 && !EditItem?.bank_id)
      error.push("Please select Bank Account");
    if (!EditItem?.date || EditItem?.date?.length != 10)
      error.push("Please Enter Date First");
    else if (data != true) error.push(...data);
    return error;
  };

  const saveAdvanceDetails = async () => {
    const error = validate();
    if (error.length) {
      store.dispatch(setOpenAlert(true));
      store.dispatch(setMessAlert(error));
      return;
    }
    try {
      store.dispatch(setLoadingMain(true));
      const body = {
        action: "saveStaffAdvance",
        agencyid: user_id,
        staff_id: EditItem?.ID,
        empCode: EditItem?.EMP_CODE,
        noOfMonths: EditItem.months,
        advanceAmount: EditItem?.advance_amount,
        modeOfPayment: EditItem?.payment_mode,
        bankId: EditItem?.bank_id || 0,
        date: EditItem?.date,
      };
      const res = await fetch(`${base_url}payroll/staffAdvanceData.php`, {
        method: "POST",
        body: JSON.stringify(body),
      }).then((r) => r.json());
      if (res.success) {
        fetchData();
        toast.success(res.message);
        setOpen(false);
        setOpen1(false);
      } else {
        store.dispatch(setOpenAlert(true));
        store.dispatch(setMessAlert(res.message));
      }
    } catch (err) {
      console.log("error ====", err);
    } finally {
      store.dispatch(setLoadingMain(false));
    }
  };

  return (
    <div className="container">
      <PageHeading
        title="STAFF ADVANCE INFO"
        right={
          <>
            <BackButton />
            <HelpButton
              link={[
                "https://youtu.be/4FzTz5cY6bc",
                "https://youtu.be/JcUiQNwM4QY",
              ]}
            />
          </>
        }
      />

      {/* List  */}
      <Pagination3
        totalCount={Math.min(totalCount, searchCount)}
        SerchInput={searchInput}
        serchChange={(e) => {
          setSearchInput(e.target.value);
          setPrevSearch(searchInput);
          setPageNo(1);
        }}
        pageNo={pageNo}
        setPageNo={setPageNo}
        entries={entries}
        setEntries={setEntries}
      >
        {advance_loading ? (
          <PageLoading />
        ) : (
          <TableNew
            mt={5}
            nodata={!advance_list?.length && !advance_loading}
            headData={[
              "EMPLOYEE CODE",
              "EMPLOYEE NAME",
              "ROLE",
              "REMAINING ADVANCE AMOUNT",
            ]}
            body={
              <>
                {advance_list?.map((item, i) => (
                  <tr key={i}>
                    <td
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        if (item?.IS_SALARY_DATA == 1) {
                          setEditItem(item);
                          setOpen(true);
                        } else {
                          store.dispatch(setOpenAlert(true));
                          store.dispatch(
                            setMessAlert(
                              "Please fill salary details first for this employee"
                            )
                          );
                        }
                      }}
                    >
                      {item?.EMP_CODE}
                    </td>
                    <td>{item?.EMP_NAME}</td>
                    <td>{getRoleOption(item?.ROLE)}</td>
                    <td>{item?.OUTSTANDING_ADVANCE}</td>
                  </tr>
                ))}
              </>
            }
          />
        )}
      </Pagination3>

      {/* Add Loans */}
      {open && (
        <SmallModal
          style={{ minWidth: "550px" }}
          isOpen={open}
          setIsOpen={setOpen}
          okbtn
          title={`STAFF DETAILS :  ${EditItem?.EMP_NAME?.toUpperCase()} - ${
            EditItem?.EMP_CODE
          }`}
          okBtnText="SAVE"
          ok_btn_click={() => setOpen1(true)}
        >
          <div
            className="credit-limit"
            style={{
              "--credit-width": "50%",
              justifyContent: "flex-start",
              textAlign: "left",
              rowGap: "1rem",
            }}
          >
            <Input
              label="ADVANCE AMOUNT"
              placeholder="ADVANCE AMOUNT"
              value={EditItem?.advance_amount}
              onChange={(e) => {
                const value = e.target.value;
                if (
                  (value?.length <= 10 && NumberDecimalEntry(value)) ||
                  value === "" ||
                  value === "-"
                ) {
                  setEditItem({ ...EditItem, advance_amount: value });
                }
              }}
            />
            <Dropdown
              width2={""}
              label="MODE OF PAYMENT"
              value={EditItem?.payment_mode}
              onChange={(e) => {
                const value = e.target.value;
                setEditItem({
                  ...EditItem,
                  payment_mode: value,
                  bank_id: value == 1 ? "" : EditItem?.bank_id,
                });
              }}
              options={
                <>
                  <option value="">SELECT</option>
                  <option value="1">CASH</option>
                  <option value="2">CHEQUE</option>
                  <option value="3">ONLINE</option>
                </>
              }
            />
            <Dropdown
              width2={""}
              label="BANK"
              disabled={EditItem?.payment_mode == 1}
              value={EditItem?.bank_id}
              onChange={(e) =>
                setEditItem({ ...EditItem, bank_id: e.target.value })
              }
              options={
                <>
                  <option value="">SELECT</option>
                  {bank_master_list
                    ?.filter(
                      (v) =>
                        v?.BANK_CODE == "OVER DRAFT" ||
                        v?.BANK_CODE == "LOAN" ||
                        v?.BANK_CODE == "SAVINGS" ||
                        v?.BANK_CODE == "CURRENT"
                    )
                    ?.map((v, i) => (
                      <option key={i} value={v?.ID}>
                        {bankCode(v)}
                      </option>
                    ))}
                </>
              }
            />
            <Input
              label="DATE"
              type={"date"}
              max={moment(new Date()).format("YYYY-MM-DD")}
              placeholder="DATE"
              value={EditItem?.date}
              onChange={(e) => {
                const value = e.target.value;
                if (value?.length == 10) {
                  setEditItem({ ...EditItem, date: value });
                }
              }}
            />
          </div>
        </SmallModal>
      )}
      {open1 && (
        <SmallModal
          title={"Confirm"}
          isOpen={open1}
          setIsOpen={setOpen1}
          mess={
            "Please verify That Sum Of Advance Amount Should Not Exceed The Employee Salary Or Delivery Commission Amount"
          }
          onClick={saveAdvanceDetails}
          bname={"SAVE"}
        />
      )}
    </div>
  );
};

export default Advance;
